import { render, staticRenderFns } from "./task_index.vue?vue&type=template&id=384790bd&"
import script from "./task_index.vue?vue&type=script&lang=js&"
export * from "./task_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports